import React, { Component } from 'react';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import {
	changeCurrentPath,
	startUploadProcess,
	uploadData,
	setUploadList,
	deleteUploadList,
	saveUploadCsv,
	resetUploadState,
	getCsvTemplate,
	fetchCsvTemplateInfo
} from '../../actions';
import classNames from 'classnames';
import Dropzone from 'react-dropzone'
import Encoding from 'encoding-japanese';
import csv from 'csvtojson';
import _ from 'lodash';

import {getValueArray, getValueHash} from '../../common/utils/array';

import Header from '../../common/containers/header';
import Progress from '../../common/containers/progress'
import SpNav from '../../common/containers/sp_nav'
import Footer from '../../common/containers/footer';
import MainButtons from '../../common/components/main-buttons';

import ErrorDialog from '../../common/components/dialog/error-dialog';
import ReloadModal from '../../common/components/dialog/reload-dialog';
import LogoutModal from '../../common/components/dialog/logout-dialog';

import Complete from './components/complete';
import ErrorDetail from './components/error_details';
import AlertDialog from '../../common/components/dialog/alert-dialog';

import Button from '@material-ui/core/Button';
import red from '@material-ui/core/colors/red';


import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';




const styles = theme => ({
	abortButton:{
		backgroundColor:red[500],
		'&:hover': {
			backgroundColor: red[800],
		},
		color: theme.palette.getContrastText(red[500]),
	},
	selectTemplate:{
		marginBottom: 20
	},
	selectTemplateSelect:{
		backgroundColor:'#f5fbfd',
		'&:hover': {
			backgroundColor: '#e9f5f9',
		},
	}
});


class Upload extends Component {
	constructor(props) {
		super(props);
		const processDivide = !("divide" in props.match.params) || !props.match.params.divide ? "1" : props.match.params.divide;
		this.state = {
			dragging : false,
			uploadList : [],
			errorList : [],
			isErrorOpen : false,
			dialogOpen:false,
			dialogFunc:undefined,
			templateValue:0,
			templateInfo:null,
			mappingErrorOpen:false,
			isErrorTitle:"エラー詳細",
			processDivide
		}
	}

	/** override methods **/

	UNSAFE_componentWillMount(){
		const { dispatch,auth} = this.props;
		this.getMappingSettingInfo(this.state.processDivide);
		dispatch(deleteUploadList({
			process_divide:0,
			SessionID:auth.SessionID,
			processDivide: this.state.processDivide
		}));
	}

	componentDidMount() {
		const { dispatch, history } = this.props;
		window.scrollTo(0, 0);
		dispatch(changeCurrentPath({ currentPath: history.location.pathname }));


	}

	componentWillUnmount(){
		const { dispatch } = this.props;
		dispatch(setUploadList({
			uploadList:[],
			lastFileManageNO:0
		}));
	}

	/** event handlers **/
	_handleDrop() {
		this.setState({
			dragging:false
		});
	}

	_handleDragOver(e) {}

	_handleDragEnter(e) {
		this.setState({
			dragging:true
		});
	}

	_handleDragLeave(e) {
		this.setState({
			dragging:false
		})
	}

	_handleDropAccepted(files) {
		const {dispatch,settings} = this.props;
		const lastFileManageNO = settings.lastFileManageNO;

		dispatch(startUploadProcess());
		let uploadList = getValueArray(settings.uploadList);

		files.forEach((file,index)=>{
			const fileManageNO = lastFileManageNO+index+1;
			const duplicate = _.filter(uploadList,(item)=>{
				return _.includes(item.FILES["name"], file["name"]);
			});
			if(duplicate.length){
				uploadList.push({
					STATUS:'NG',
					FILE_MANAGE_NO:fileManageNO,
					FILES:file,
					MSG:'同一名のファイルが既に選択されています'
				});
				dispatch(setUploadList({uploadList,lastFileManageNO:fileManageNO}));
				if(files.length === 1){
					dispatch(setUploadList({isFetching:false}));
				}
				return;
			}



			const reader = new FileReader();
			reader.readAsArrayBuffer(file);
			reader.onload = (e) => {
				const codes = new Uint8Array(e.target.result);
				const encoding = (Encoding.detect(codes) === "UNICODE") ? "SJIS" : Encoding.detect(codes);
				const unicodeString = Encoding.convert(codes, {
					to: 'unicode',
					from: encoding,
					type: 'string',
				});

				csv({
					flatKeys: true
				}).fromString(unicodeString)
				.then((csvRow)=>{
					if(csvRow.length === 0){
						uploadList.push({
							STATUS:'NG',
							FILE_MANAGE_NO:fileManageNO,
							FILES:file,
							MSG:'このファイルにはデータ行がありません'
						});
						dispatch(setUploadList({uploadList,lastFileManageNO:fileManageNO,isFetching:false}));
					}
					else{
						uploadList.push({STATUS:'ON_PROCESS',FILE_MANAGE_NO:fileManageNO,FILES:file});
						dispatch(setUploadList({uploadList,lastFileManageNO:fileManageNO}));
						dispatch(uploadData({
							data:csvRow
							,	SessionID:this.props.auth.SessionID
							,	file_manage_no:	fileManageNO
							,	templateInfo : this.state.templateInfo
							,	processDivide : this.state.processDivide
						}));
					}

				})
			};
		});


	}


	_handleDropRejected(files,event) {
		const {dispatch, settings} = this.props;
		let lastFileManageNO = settings.lastFileManageNO;
		let uploadList = getValueArray(settings.uploadList);

		if(files.length>1){
			const fileManageNO = lastFileManageNO+1;
			uploadList.push({
				STATUS:'NG',
				FILE_MANAGE_NO:fileManageNO,
				FILES:{size:"-",name:"複数ファイル"},
				MSG:'複数ファイルを同時にUPLOADできません'
			});

			lastFileManageNO += fileManageNO;
		}
		else{
			files.forEach((file,index)=>{
				const fileManageNO = lastFileManageNO+index+1;
				uploadList.push({
					STATUS:'NG',
					FILE_MANAGE_NO:fileManageNO,
					FILES:file,
					MSG:'CSV形式のみアップロード可能'
				});
			});
			lastFileManageNO += lastFileManageNO+Object.keys(files).length;
		}

		dispatch(setUploadList({uploadList,lastFileManageNO}));
	}

	_onClickDeleteFile(fileManageNO){
		const {dispatch, settings, auth} = this.props;
		let uploadList = getValueArray(settings.uploadList);
		_.remove(uploadList, function(list) { return list["FILE_MANAGE_NO"] === fileManageNO; });
		dispatch(setUploadList({uploadList}));
		dispatch(deleteUploadList({
			process_divide:1,
			SessionID:auth.SessionID,
			file_manage_no : fileManageNO,
			processDivide : this.state.processDivide
		}));

	}

	handleClickSave = event =>{
		const {dispatch,auth} = this.props;
		dispatch(saveUploadCsv({
			SessionID:auth.SessionID,
			processDivide : this.state.processDivide
		}))
	};

	handleCompleteClose = event =>{
		const {dispatch} = this.props;
		dispatch(resetUploadState());
	};

	handleOpenErrorDisplay(data,title){
		this.setState({
			errorList:data,
			isErrorOpen:true,
			isErrorTitle:title
		});
	};
	handleCloseErrorDisplay = event =>{
		this.setState({
			errorList:[],
			isErrorOpen:false
		});
	};

	handleClickDL = event => {
		this.props.dispatch(getCsvTemplate({
			templateInfo : this.state.templateInfo,
			processDivide : this.state.processDivide
		}));
	};

	handleClickMapping = event => {

		if(this.props.auth.user.IsMappingOptionAvailable){
			this.props.history.push('/mapping/step1/'+this.state.processDivide);
		}
		else{
			this.setState({
				mappingErrorOpen:true
			});
		}
	};
	handleClickBack = event => {
		const OKList = _.filter(this.props.settings.uploadList,(item)=>{
			return _.includes(item.STATUS, 'OK');
		});

		if(OKList.length){
			this.setState({
				dialogOpen:true,
				dialogFunc:'BACK'

			})
		}
		else{
			if(this.state.processDivide === "1"){
				this.props.history.push('/main-list');
			}
			else{
				this.props.history.push('/shipment');
			}

		}
	};

	handleDoAfterDialog = event =>{
		if(this.state.dialogFunc === 'BACK'){
			if(this.state.processDivide === "1"){
				this.props.history.push('/main-list');
			}
			else{
				this.props.history.push('/shipment');
			}
		}
		else{

		}
	};

	handleCancelDialog = event =>{
		this.setState({
			dialogOpen:false
		})
	};

	handleChangeTemplateValue = (event) =>{
		const csvList = this.props.settings.csvTemplateList;
		const index = _.findIndex(csvList,{TemplateID:event.target.value});
		let templateInfo = null;
		if(index >= 0){
			templateInfo = getValueHash(csvList[index]);
		}
		this.setState({
			templateValue : event.target.value,
			templateInfo
		});
	};

	/** private method **/
	getFileSize(bytes) {
		if(isNaN(bytes)) return bytes;
		const thresh = 1000;
		if(Math.abs(bytes) < thresh) {
			return bytes + ' B';
		}
		const units = ['kB','MB','GB','TB','PB','EB','ZB','YB'];
		let u = -1;
		do {
			bytes /= thresh;
			++u;
		} while(Math.abs(bytes) >= thresh && u < units.length - 1);
		return bytes.toFixed(1)+' '+units[u];
	}

	getMappingSettingInfo = (processDivide) =>{
		const { dispatch, auth } = this.props;
		dispatch(fetchCsvTemplateInfo({
			SessionID : auth.SessionID,
			processDivide
		}));
	};

	handleCloseMappingError = () =>{
		this.setState({
			mappingErrorOpen:false
		});
	};


	render() {
		const {classes,settings} = this.props;
		const {errorList,isErrorOpen,isErrorTitle, templateValue,mappingErrorOpen,processDivide} = this.state;
		const uploadList = settings.uploadList;
		const OkList = _.filter(uploadList,(item)=>{
			return _.includes(item.STATUS, 'OK');
		});

		const templateInfo = settings.csvTemplateList;
		const selectDisabled = (uploadList.length > 0) ? true : false;

		const mainButtons = [
			{type:'CALC',func:this.handleClickMapping,text:<span>TPL<br/>作成/編集</span>},
			{type:'DL',func:this.handleClickDL,text:"TPL DL"},
			{type:'BACK',func:this.handleClickBack,text:"一覧"}
		];


		const navigations = [
			{name:processDivide === "2" ? '車番登録' : '一覧',clickFunc:this.handleClickBack}
		];

		const limitText = <span>ここからは有料サービスです。（月額利用料　要相談）<br/>
			サービス内容は最新のユーザーマニュアルを参照してください。<br/>
			サービスの詳細、お試し利用、ご契約等に関するお問い合わせは下記宛先にご連絡下さい。<br/>
			<br/>
			(株)TSUNAGUTE　担当者宛<br/>
			<a href="mailto:customer@tsunagute.co.jp">customer@tsunagute.co.jp</a></span>;

		const IsMappingOptionAvailable = this.props.auth.user.IsMappingOptionAvailable;

		return (
			<div id="main_container">
				{settings.isCompleteSave &&
					<Complete
						dataSource={settings.saveFileList}
						afterCloseFunc={this.handleCompleteClose}
						processDivide={this.state.processDivide}
					/>
				}
				{isErrorOpen &&
				<ErrorDetail
					dataSource={errorList}
					afterCloseFunc={this.handleCloseErrorDisplay}
					titles={isErrorTitle}
				/>
				}
				{(settings.isFetching || settings.isSaving) &&
				<Progress/>
				}
				<SpNav history={this.props.history}/>
				<Header
					history={this.props.history}
					navigations={navigations}
				/>
				<article>
					<section className="title_area">
						<h2>{processDivide === "2" && "車番情報"}CSVアップロード</h2>
					</section>
					{IsMappingOptionAvailable > 0 &&
					<section className={"with_button"}>
						<FormControl variant="outlined" className={classes.selectTemplate} fullWidth>
							<InputLabel htmlFor="outlined-age-simple">
								テンプレートの選択
							</InputLabel>
							<Select
								value={templateValue}
								onChange={this.handleChangeTemplateValue}
								disabled={selectDisabled}
								input={
									<OutlinedInput
										labelWidth={145}
										name="age"
										id="outlined-age-simple"
									/>
								}
								className={classes.selectTemplateSelect}
							>
								<MenuItem value={0}>
									規定のテンプレート
								</MenuItem>
								{templateInfo.map((info, index) => {
									return (
										<MenuItem value={info.TemplateID} key={index}>
											{info.TemplateName}
										</MenuItem>
									)
								})}
							</Select>
						</FormControl>
					</section>
					}

					<section id="uploads" className="with_button">
						<Dropzone
							className={classNames("uploads_dropzone",{"is_over":this.state.dragging})}
							onDrop={this._handleDrop.bind(this)}
							onDragEnter={this._handleDragEnter.bind(this)}
							onDragLeave={this._handleDragLeave.bind(this)}
							onDragOver={this._handleDragOver.bind(this)}
							onDropAccepted={this._handleDropAccepted.bind(this)}
							onDropRejected={this._handleDropRejected.bind(this)}
							accept=".csv"
							multiple={false}
						>
							{processDivide === "2" ?
								<div className="uploads_dropzone_inner">
									<span className={"shipment_inner"}>
										こちらは車番情報専用 CSVアップロードエリアです
									</span><br />
									ここにファイルをドロップしてください。
									<span>※指定フォーマット以外のファイルは取りこめません</span>
								</div>
								:
								<div className="uploads_dropzone_inner">
									ここにファイルをドロップしてください。
									<span>※指定フォーマット以外のファイルは取りこめません</span>
								</div>
							}
						</Dropzone>
						{uploadList.map((dt,index)=>{
							const file_size = this.getFileSize(dt.FILES.size);
							const hasIgnore = Boolean(dt.STATUS === 'OK' && "IGNORE_DET" in dt && dt["IGNORE_DET"].length > 0);
							const hasCutout = Boolean(dt.STATUS === 'OK' && !hasIgnore && "CUTOUT_DET" in dt && dt["CUTOUT_DET"].length > 0);

							return (
								<div className="statusbar" key={index}>
									<div className="filename">{dt.FILES.name}</div>
									<div className="filesize">{file_size}</div>
									{
										(dt.STATUS === 'OK' && !hasCutout && !hasIgnore &&
										<div className="progewssBar">
											<div>アップロード完了</div>
										</div>
										)
										||
										(dt.STATUS === 'OK' && hasIgnore &&
											<div className="not_upload records" onClick={this.handleOpenErrorDisplay.bind(this,dt.IGNORE_DET,"エラー詳細")}>アップロード完了 ※エラーあり(エラーレコードは登録されません)</div>
										)
										||
										(dt.STATUS === 'OK' && hasCutout &&
											<div className="not_upload records" onClick={this.handleOpenErrorDisplay.bind(this,dt.CUTOUT_DET,"データ切り捨て詳細")}>アップロード完了 ※データの切り捨てが発生します</div>
										)
										||
										(dt.STATUS === 'ON_PROCESS' &&
										<div className="progewssBar">
											<div>処理中…</div>
										</div>
										)
										||
										(dt.STATUS === 'RECORD_NG' &&
										<div className="not_upload records" onClick={this.handleOpenErrorDisplay.bind(this,dt.ERROR_DET,"エラー詳細")}>{dt.MSG}</div>
										)
										||
										<div className="not_upload">{dt.MSG}</div>
									}
									<Button
										className={classNames('abort',classes.abortButton)}
										onClick={this._onClickDeleteFile.bind(this,dt.FILE_MANAGE_NO)}
									>
										取消
									</Button>
								</div>
							)
						})}
						{OkList.length > 0 &&
						<div id="import_btn" className="clearfix">
							<Button variant="contained" color="primary" size="large" id="btn_import" onClick={this.handleClickSave}>
								取込実行
							</Button>
						</div>
						}
					</section>
				</article>
				<MainButtons buttons={mainButtons}/>
				<Footer/>
				<AlertDialog
					open={this.state.dialogOpen}
					title={"確認"}
					text={<span>未取込みのファイルは破棄されます</span>}
					okFunction={this.handleDoAfterDialog}
					closeFunction={this.handleCancelDialog}
				/>
				<ErrorDialog
					open={mappingErrorOpen}
					title={'ご利用制限'}
					text={limitText}
					afterCloseFunc={this.handleCloseMappingError}
				/>
				<ErrorDialog
					open={this.props.settings.isProcessError}
				/>
				<ReloadModal />
				<LogoutModal />
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		navigation : state.navigation,
		auth: state.auth,
		settings : state.uploadSettings
	};
}
export default compose(
	withStyles(styles),
	connect(mapStateToProps)
)(Upload);




// WEBPACK FOOTER //
// ./src/routes/upload/index.js